import { z } from "zod"

export const forecastCalculatorSchema = z
   .object({
      weeklySales: z
         .number({ invalid_type_error: "Please enter a number" })
         .min(1, "Weekly sales must be greater than 0"),

      laborPercent: z
         .number({ invalid_type_error: "Please enter a number" })
         .min(0.1, "Labor % must be greater than 0")
         .max(100, "Labor % cannot exceed 100"),

      currentAccuracy: z
         .number({ invalid_type_error: "Please enter a number" })
         .min(0, "Current forecast accuracy cannot be negative")
         .max(100, "Current forecast accuracy cannot exceed 100"),

      targetAccuracy: z
         .number({ invalid_type_error: "Please enter a number" })
         .min(0, "Target forecast accuracy cannot be negative")
         .max(100, "Target forecast accuracy cannot exceed 100"),

      locations: z
         .number({ invalid_type_error: "Please enter a number" })
         .min(1, "Number of locations must be at least 1"),
   })
   .refine((data) => data.targetAccuracy >= data.currentAccuracy, {
      message: "Target accuracy cannot be lower than current accuracy",
      path: ["targetAccuracy"],
   })

export type ForecastCalculatorFormValues = z.infer<typeof forecastCalculatorSchema>
